
import { defineComponent, onMounted, ref } from 'vue'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { ResponseSettingItem } from '@/repositories/fuzoku-meisai/data'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import { kaikeikijunRepositories } from '@/repositories/fuzoku-meisai/kaikei-kijun/kaikeikijunRepositories'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { callApiWrapper } from '@/views/callApiWrapper'
import { PostParam } from '@/repositories/fuzoku-meisai/kaikei-kijun/mokurokuRepository'
import KaikeiKijunSettingTitle from '@/views/fuzoku-meisai/kaikei-kijun/KaikeiKijunSettingTitle.vue'

const repository = kaikeikijunRepositories.mokuroku
const emptySetting: ResponseSettingItem = { sources: [], targets: [] }

export default defineComponent({
  components: {
    KaikeiKijunSettingTitle,
    ResponseResultAlert,
    LoadingButton,
    ContentLayout,
    SettingPanel
  },

  setup () {
    const loading = ref(false)
    const isSucceedResponse = ref(false)
    const requestError = ref<string | null>(null)
    const currentAssetsSetting = ref<ResponseSettingItem>(emptySetting)
    const fixAssetsSetting = ref<ResponseSettingItem>(emptySetting)
    const totalDebtSetting = ref<ResponseSettingItem>(emptySetting)
    const landOwnershipStatus = ref<string>('')
    const buildingOwnershipStatus = ref<string>('')

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        await refreshUiData()
      })
      loading.value = false
    })

    const onUpdatedSetting = (panelName: string, settingItem: ResponseSettingItem) => {
      switch (panelName) {
        case 'CurrentAssets':
          currentAssetsSetting.value = settingItem
          break
        case 'FixAssets':
          fixAssetsSetting.value = settingItem
          break
        case 'TotalDebt':
          totalDebtSetting.value = settingItem
          break
        default:
          console.error(`unknown panel name. name: ${panelName}`)
          break
      }
    }

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()
      await callApiWrapper(requestError, async () => {
        const postParam: PostParam = {
          landOwnershipStatus: landOwnershipStatus.value,
          buildingOwnershipStatus: buildingOwnershipStatus.value,
          currentAssets: currentAssetsSetting.value.targets,
          fixedAssets: fixAssetsSetting.value.targets,
          totalDebt: totalDebtSetting.value.targets
        }
        await repository.save(postParam)
        await refreshUiData()
        isSucceedResponse.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedResponse.value = false
      requestError.value = null
    }

    const refreshUiData = async () => {
      const data = await repository.list()
      landOwnershipStatus.value = data.landOwnershipStatus
      buildingOwnershipStatus.value = data.buildingOwnershipStatus
      currentAssetsSetting.value = data.currentAssets
      fixAssetsSetting.value = data.fixedAssets
      totalDebtSetting.value = data.totalDebt
    }

    return {
      isSucceedResponse,
      requestError,
      loading,
      currentAssetsSetting,
      fixAssetsSetting,
      totalDebtSetting,
      landOwnershipStatus,
      buildingOwnershipStatus,
      onUpdatedSetting,
      onClickRegister,
      onDismissAlert
    }
  }
})
